import './ReactMultiTeaser.scss'

import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { getFlexOffersLength } from '../../../utils/rule-builder-util'
import { ContentType, Flexoffers } from '../../../utils/types'
import { Placeholder } from '../../shared/ReactBootstrap'
import { ContentFragment, ImageType, variantClass, Variation } from '../types'

interface ReactMultiTeaserSkeletonProps {
  columnClass: string
  hasTwoCards: boolean
  imageType: string
  newContentFragments: Array<ContentFragment>
  contentType: ContentType
  variation: Variation
  flexOffers?: Flexoffers
}
const ReactMultiTeaserSkeleton = ({
  columnClass,
  hasTwoCards,
  imageType,
  newContentFragments,
  contentType,
  variation,
  flexOffers
}: ReactMultiTeaserSkeletonProps) => {
  const reactMultiTeaserRenderSkeleton = (index: number) => {
    return (
      <div
        className={`col-md-12 ${columnClass} cards-container`}
        key={`react-multi-teaser${index}}`}
        data-testid='react-multi-teaser-card'
      >
        {imageType === ImageType.square && (
          <div className='squareImage' data-testid='squareImage'>
            <div className='squareImage squareBgImage skeleton-img-placeholder' />
          </div>
        )}
        <div
          className={`react-multi-teaser-card  react-multi-teaser-card-body ${
            variation !== Variation.neutral && variation !== Variation.white && 'react-teaser-color'
          } ${variantClass[variation]} ${index % 2 === 0 ? 'even' : 'odd'}`}
          style={{
            borderTopLeftRadius: imageType === ImageType.square ? 0 : '20',
            borderTopRightRadius: imageType === ImageType.square ? 0 : '20'
          }}
        >
          {imageType !== ImageType.square && (
            <div className={`profileImage squareBgImage ${variantClass[variation]}`} data-testid='profileImage'>
              <div className={`profileImage squareBgImage ${variantClass[variation]} skeleton-img-placeholde`} />
            </div>
          )}
          <Placeholder className='eyebrow' xs={5} />
          <Placeholder className='heading' xs={7} />
          <Placeholder className='description' xs={7} />

          <Placeholder.Button xs={5} variant={ButtonTypes.PRIMARY} />
        </div>
      </div>
    )
  }

  return (
    <div data-testid={`react-multi-teaser-container`} className={`react-multi-teaser-container ${hasTwoCards && 'two-up'}`}>
      <Placeholder className='main-eyebrow' xs={7} />
      <Placeholder className='text-sm text-md main-title' xs={7} />
      <Placeholder className='main-description' xs={7} />

      <div data-testid='react-multi-teaser-cards-container' className='react-multi-teaser-cards-container overflow-hidden'>
        <div className='react-multi-teaser-cards-wrapper row'>
          {newContentFragments.map((item: ContentFragment, index: number) => {
            const flexOffersLength: number = getFlexOffersLength(flexOffers)
            if (contentType === 'static' || (contentType === 'dynamic' && index < flexOffersLength)) {
              return reactMultiTeaserRenderSkeleton(index)
            }
            return null
          })}
        </div>
      </div>
    </div>
  )
}

export default ReactMultiTeaserSkeleton
